import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useState } from 'react'

const DatePickerField = ({disableFuture,disablePast,minDate,maxDate,label,value,timePicker,onDateChange,onTimeChange,fontsize }) => {
  const [openCustomPicker,setOpenCustomPicker] = useState(false)
  return (<div>
    <label className="UI-label" style={{fontSize:fontsize}}>{label}</label>
    <div style={{ display: "flex", gap: "8px" }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                disableFuture={disableFuture || false}
                                disablePast={disablePast || false}
                                showTodayButton
                                open={openCustomPicker}
                                onOpen={() =>setOpenCustomPicker(true)}
                                onClose={() =>setOpenCustomPicker(false)}
                                minDate={minDate}
                                maxDate={maxDate}
                                value={value? dayjs(value): null}
                                onChange={onDateChange}
                                renderInput={(params) => (
                                  <div
                                    style={{
                                      position: "relative",
                                      flex: 1,
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>setOpenCustomPicker(true)}
                                  >
                                    <input
                                      {...params.inputProps}
                                      ref={params.inputRef}
                                      className="UI-input"
                                      placeholder="Date"
                                      style={{
                                        width: "100%",
                                        paddingRight: "40px",
                                        cursor: "pointer",
                                        fontSize:fontsize
                                      }}
                                      readOnly
                                    />
                                    <div
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize:fontsize
                                      }}
                                    >
                                      {params.InputProps.endAdornment}
                                    </div>
                                  </div>
                                )}
                              />
                            </LocalizationProvider>
                            {timePicker && 
                            <input
                              type="time"
                              className="UI-input tw-mb-1"
                              style={{ width: "110px", flexShrink: 1,fontSize:fontsize }}
                              value={value?dayjs(value).format("HH:mm"):"00:00"}
                              onChange={onTimeChange}
                            />}
                          </div>
                          </div>
  )
}

export default DatePickerField